module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Part"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110264-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110264-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("SIR WALTER SCOTT BAR"), _c('sup', [_vm._v("T")]), _c('br'), _vm._v(" of "), _c('br'), _vm._v(" Abbotsford"), _c('br'), _vm._v(" HIS. GURNAL"), _c('sup', [_vm._v("*")]), _c('br'), _vm._v(" Vol. I.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block epigraph",
    attrs: {
      "id": "rw-block-epigraph_110264-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_vm._v("As I walked by myself "), _c('br'), _vm._v(" I talkd to my self\n            ")]), _vm._v(" "), _c('p', [_vm._v("And thus my self said to me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Old Song.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110264-00001"
    }
  }, [_vm._v("A hard word so spelld on Authority of Miss Scott now Mrs. Lockhart.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15009e1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674951_part_01.vue
// module id = 84
// module chunks = 0